module.exports = __webpack_public_path__ + "img/cryptocurrency.0a41dbd.svg";